module.exports = ".perSecTab {\n  width: 45%; }\n\na {\n  width: 100%; }\n"